import api from '@shared/api';

import {
    SearchPayload,
    SearchResponse,
    ViolationThresholdDto,
    ViolationThresholdPayload,
    ViolationTypeDto,
    ViolationTypePayload,
} from './types';

const DDA_PATH = 'dda/api/v1';
const NSI_PATH = 'dda-trs-nsi-api/api/v1';

export const fetchViolationThresholds = async (payload: SearchPayload) =>
    (
        await api.post<SearchResponse<ViolationThresholdDto>>(
            `${DDA_PATH}/dict_violation_threshold/search`,
            payload,
        )
    ).data;

export const createViolationThreshold = async (payload: ViolationThresholdPayload) =>
    (await api.post<ViolationThresholdDto>(`${DDA_PATH}/dict_violation_threshold/`, payload)).data;

export const updateViolationThreshold = async ({
    id,
    payload,
}: {
    id: string;
    payload: ViolationThresholdPayload;
}) =>
    (await api.put<ViolationThresholdDto>(`${DDA_PATH}/dict_violation_threshold/${id}`, payload))
        .data;

export const fetchViolationTypes = async () =>
    (
        await api.post<SearchResponse<ViolationTypeDto>>(`${NSI_PATH}/dict_violation_type/search`, {
            page: {page: 0, size: 10000},
        })
    ).data;

export const updateViolationType = async ({
    id,
    payload,
}: {
    id: string;
    payload: ViolationTypePayload;
}) => (await api.put<ViolationTypeDto>(`${NSI_PATH}/dict_violation_type/${id}`, payload)).data;
